module.exports = __webpack_public_path__ + "img/reserve_web_icon.f0cf1195.svg";